import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup} from '@angular/forms';
import {BiolinkWidgetsService} from '../biolink-widgets.service';
import {BehaviorSubject} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {BiolinkEditorService} from '../../biolink-editor.service';

export interface CrupdateWidgetDialogData {
    biolinkId: number;
    widgetId?: number;
    config?: object;
}

@Component({
    selector: 'image-widget-modal',
    templateUrl: './image-widget-modal.component.html',
    styleUrls: ['./image-widget-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageWidgetModalComponent {
    form = new FormGroup({
        url: new FormControl(),
        destinationUrl: new FormControl(),
        type: new FormControl('default'),
    });

    constructor(
        private dialogRef: MatDialogRef<ImageWidgetModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CrupdateWidgetDialogData,
        public editor: BiolinkEditorService
    ) {
        if (data.config) {
            this.form.patchValue(data.config);
        }
    }

    createOrUpdate() {
        this.editor
            .crupdateWidget(this.data.widgetId, 'image', this.form.value)
            .subscribe(response => {
                this.dialogRef.close(response.widget);
            });
    }

    close() {
        this.dialogRef.close();
    }
}
